/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiimagepromptlabel3Inputs */

const en_aiimagepromptlabel3 = /** @type {(inputs: Aiimagepromptlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What should the image show?`)
};

const de_aiimagepromptlabel3 = /** @type {(inputs: Aiimagepromptlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was soll auf dem Bild zu sehen sein?`)
};

/**
* | output |
* | --- |
* | "What should the image show?" |
*
* @param {Aiimagepromptlabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiimagepromptlabel3 = /** @type {((inputs?: Aiimagepromptlabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiimagepromptlabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiimagepromptlabel3(inputs)
	return de_aiimagepromptlabel3(inputs)
});
export { aiimagepromptlabel3 as "aiImagePromptLabel" }